import { takeLatest, put } from 'redux-saga/effects';

import { DialogsTypes } from './types';
import * as DialogsActions from './actions';

// Sagas
function* setOpen({ payload }: any) {
  try {
    yield put(DialogsActions.setOpen({ ...payload }));
  } catch (err) {
    console.error('dialogs - setOpen - err', err);
  }
}

function* setClose() {
  try {
    yield put(DialogsActions.setClose());
  } catch (err) {
    console.error('dialogs - setClose - err', err);
  }
}

function* setSecondOpen({ payload }: any) {
  try {
    yield put(DialogsActions.setSecondOpen({ ...payload }));
  } catch (err) {
    console.error('dialogs - setSecondOpen - err', err);
  }
}

function* setSecondClose() {
  try {
    yield put(DialogsActions.setSecondClose());
  } catch (err) {
    console.error('dialogs - setSecondClose - err', err);
  }
}

export const dialogsSagas = [
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === DialogsTypes.SET_OPEN && Object.keys(ac).length === 1,
    setOpen,
  ),
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === DialogsTypes.SET_CLOSE && Object.keys(ac).length === 1,
    setClose,
  ),
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === DialogsTypes.SET_SECOND_OPEN && Object.keys(ac).length === 1,
    setSecondOpen,
  ),
  takeLatest(
    (ac: { type?: any }) =>
      ac.type === DialogsTypes.SET_SECOND_CLOSE && Object.keys(ac).length === 1,
    setSecondClose,
  ),
];
